import { MouseEvent, useState } from "react";

export const useMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);

  const onOpen = (event: MouseEvent<HTMLElement>) => {
    event.currentTarget.focus();
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  return {
    anchorEl,
    open,
    onOpen,
    onClose,
  };
};
